import { Row, Col } from 'antd';
const CommonMainLayout = (props) => {
    const element = (<Row className='main_row'>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 20, offset: 2 }} xl={{ span: 18, offset: 3 }}>
            {props.children}
        </Col>
    </Row>);
    return element
}
export default CommonMainLayout